// extracted by mini-css-extract-plugin
export default {"MainMenu":"MainPage_MainMenu__hkLxi","Banner":"MainPage_Banner__Dg80H","Divider":"MainPage_Divider__0jLYo"};